<template>
  <div class="home-hero-bg">
    <div class="home-hero">

      <div class="home-hero-title">
        <img src="@/assets/images/Hero_Logo_SVG.svg" align="middle" alt="">
        <h1>{{ $t('home-page.hero-title') }}</h1>
      </div>

      <img class="hero-image" src="@/assets/images/Home_Hero_2_Asset.svg" alt="">

      <div class="home-hero-subtitle-parent">
        <div class="home-hero-subtitle">
          <h1 class="home-hero-paragraph">{{ $t('home-page.hero-paragraph') }}</h1>
        </div>

        <div class="home-hero-cta">
          <s-button class="button-primary-inverted" btn-link="/signup">{{$t('actions.try')}}</s-button>
          <s-button class="button-primary" btn-link="/pricing#pricing-plans">{{$t('actions.go-premium')}}</s-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SButton from "@/components/SButton.vue";

export default {
  name: 'HomeHero',
  components: {
    SButton,
  },
  props: {
    msg: String
  }
}
</script>
